import type { PlaceCreateInput, PlaceImportFromGmapsResponse } from '@upme/contracts';
import { slugify } from '@upme/domain';

type Prefill = Extract<PlaceImportFromGmapsResponse, { kind: 'prefill' }>;

export function prefillToFormValues(p: Prefill): Partial<PlaceCreateInput> & { googlePlaceId?: string } {
  // exactOptionalPropertyTypes: omit keys instead of setting `undefined`.
  const out: Partial<PlaceCreateInput> & { googlePlaceId?: string } = {
    name: p.name,
    slug: slugify(p.name),
    addressText: p.address,
    lat: p.lat,
    lng: p.lng,
    categoryIds: p.categoryIds,
    googlePlaceId: p.googlePlaceId,
  };
  if (p.websiteUrl != null) out.websiteUrl = p.websiteUrl;
  if (p.cityId != null) out.cityId = p.cityId;
  return out;
}
